import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, List, Spin, Modal, Radio } from "antd";
import soap_pesquisa from "../store/soap/zws_app_buscar_gp_pesquisa.js";

import IconText from "../components/common/List/IconText";

export default class ReasearchList extends Component {
  state = {
    pesquisas: [],
    load: true,
    isAtacado: false,
    modalTipoPesquisa: false,
    tipoPesquisa: "",
  };

  async componentDidMount() {
    if (localStorage.getItem("centro") !== null) {
      this.showModalTipoPesquisa();
    } else {
      this.props.history.push("/research/new");
    }

    this.setState({
      pesquisas: [],
      load: false,
    });
  }

  research(item) {
    item.isAtacado = this.state.isAtacado;
    localStorage.setItem("pesquisa", JSON.stringify(item));
    switch (item.TIPO._text) {
      case "S":
        this.props.history.push("/category/" + item.CONCORRENTE._text);
        break;
      case "F":
        this.props.history.push("/research/" + item.CONCORRENTE._text);
        break;
      case "T":
        this.props.history.push("/research/" + item.CONCORRENTE._text);
        break;
      case "E":
        this.props.history.push("/research/" + item.CONCORRENTE._text);
        break;
      default:
        this.props.history.push("/research/" + item.CONCORRENTE._text);
    }
  }

  showModalTipoPesquisa = () => {
    this.setState({
      modalTipoPesquisa: true,
    });
  };

  changeTipoPesquisa = async () => {
    let _pesquisas = [];

    if (localStorage.getItem("centro") !== null) {
      const getPesquisas = await soap_pesquisa.getPesquisa();
      this.setState({
        isAtacado: getPesquisas.atacado,
      });

      console.log("getPesquisas.items", getPesquisas.items);

      if (getPesquisas.items) {
        _pesquisas = Array.isArray(getPesquisas.items)
          ? getPesquisas.items
          : [getPesquisas.items];
        const _tipoKey = {
          Avulsa: "F",
          "Semanal/Quinzenal": "S",
          Tabela: "T",
          Exposição: "E",
        };
        _pesquisas = _pesquisas.filter(
          (_item) => _item.TIPO._text === _tipoKey[this.state.tipoPesquisa]
        );
      }
    } else {
      this.props.history.push("/research/new");
    }

    this.setState({
      modalTipoPesquisa: false,
      pesquisas: _pesquisas,
      load: false,
    });

    this.setState({
      // labelPhoto: !this.state.takePicture ? "Ver foto" : "Tirar foto",
      // takePicture: !this.state.takePicture,
    });
  };

  handleCancelTipoPesquisa = (e) => {
    this.setState({
      modalTipoPesquisa: false,
    });
  };

  render() {
    const optionsTipoPesquisa = [
      "Semanal/Quinzenal",
      "Avulsa",
      "Tabela",
      "Exposição",
    ];
    return (
      <>
        <Modal
          title="Selecione o Tipo de Pesquisa"
          style={{ top: 20 }}
          visible={this.state.modalTipoPesquisa}
          onOk={this.changeTipoPesquisa}
          onCancel={this.handleCancelTipoPesquisa}
          okText="Selecionar"
          cancelText="Fechar"
        >
          <Radio.Group
            options={optionsTipoPesquisa}
            onChange={(e) => this.setState({ tipoPesquisa: e.target.value })}
            value={this.state.tipoPesquisa}
          />
        </Modal>

        {this.state.pesquisas.length === 0 && !this.state.load && (
          <h3 style={{ textAlign: "center", margin: "50px" }}>
            Não há pesquisas no momento.
          </h3>
        )}
        {this.state.pesquisas.length > 0 && !this.state.load && (
          <List
            itemLayout="vertical"
            size="large"
            dataSource={this.state.pesquisas}
            footer={
              <div>
                <b>Total</b> {this.state.pesquisas.length} pesquisa(s)
              </div>
            }
            renderItem={(item) => (
              <List.Item
                key={item.CONCORRENTE._text}
                actions={[
                  <IconText type="tags" text={`${item.DESCRICAO._text}`} />,
                ]}
                onClick={() => {
                  this.research(item);
                }}
                style={{ cursor: "pointer" }}
              >
                <List.Item.Meta
                  title={item.NOME_CONCORRENTE._text}
                  description={`Grupo concorrente -  ${item.GRUPO_CONCORRENTE._text}`}
                />
              </List.Item>
            )}
          />
        )}
        {this.state.load && <Spin className="spin-dma" />}
        <Link to="/research/new">
          <Button
            type="primary"
            shape="round"
            icon="file-search"
            size="large"
            className="float-action-button dma-primary"
          >
            Nova pesquisa
          </Button>
        </Link>
      </>
    );
  }
}
